<template>
    <fragment>
        <v-main style="background-color: #ebebeb">
            <v-container class="set-container  fill-height">
                <v-row class="text-center justify-center my-2">
                    <v-col cols="12" lg="5" md="6">
                        <v-form ref="loginFormRef" v-model="loginForm" @submit.prevent="processLogin()">
                            <v-hover>
                                <template v-slot:default="{ hover }">
                                    <v-card :elevation="hover ? 24 : 18" class="pa-2 pa-sm-3 pa-md-8 rounded-xl"
                                            rounded="32"
                                            shaped>

                                        <!-- <v-img src="img/Confix-3.0.8.png" style="background-color:  #004E7C;"></v-img> -->

                                        <v-card-title class="d-block break-word">
                                            <login-form-header></login-form-header>
                                        </v-card-title>

                                        <v-card-text>

                                            <!------------------------------------------------
                                                Local mode fields
                                            ------------------------------------------------->


                                            <!--                                    <v-text-field-->
                                            <!--                                        v-model="email"-->
                                            <!--                                        label="Email"-->
                                            <!--                                        clearable-->
                                            <!--                                    ></v-text-field>-->
                                            <!--                                        autofocus-->
                                            <div v-if="isLocalMode">
                                                <v-text-field
                                                    v-model="clientName"
                                                    :error-messages="clientNameErrors"
                                                    :label="$gettext('Username')"
                                                    clearable
                                                    outlined
                                                    autofocus
                                                    @blur="$v.clientName.$touch()"
                                                    @input="$v.clientName.$touch()"
                                                ></v-text-field>

                                                <v-text-field
                                                    v-model="password"
                                                    :error-messages="passwordErrors"
                                                    :label="$gettext('Password')"
                                                    clearable
                                                    outlined
                                                    type="password"
                                                    @blur="$v.password.$touch()"
                                                    @input="$v.password.$touch()"
                                                ></v-text-field>
                                            </div>

                                            <ftp-mode-login-form v-if="isFtpMode"></ftp-mode-login-form>
                                            <support-mode-login-form v-if="isSupportMode"></support-mode-login-form>

                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn :class="{ 'darken-3': isDark }"
                                                   :disabled="loginInProgress"
                                                   class="my-3 pa-4 pa-md-8 rounded width-100 primary font-weight-bold body-1"
                                                   elevation="5" type="submit">
                                                <span v-if="!loginInProgress" v-text="$gettext('LOGIN')"></span>
                                                <v-progress-circular v-if="loginInProgress" color="white" indeterminate
                                                                     size="20"></v-progress-circular>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </v-hover>
                        </v-form>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <v-footer fixed>
            <v-row>
                <v-col class="footer-wrapper" cols="12">
                    <strong>&copy; Lightphone</strong>&nbsp;{{ new Date().getFullYear() }} {{ appVersion }} — {{
                        $gettext('All Rights Reserved')
                    }}
                    <language-chooser></language-chooser>
                </v-col>
            </v-row>
        </v-footer>
        <snackbar ref="snackbar"></snackbar>
    </fragment>
</template>
<script>

// @ is an alias to /src
import Vue from 'vue'
import Fragment from 'vue-fragment'
import Vuelidate from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'
import VueSweetalert2 from 'vue-sweetalert2'
import MixinIcon from '@/mixins/MixinIcon'
import 'sweetalert2/dist/sweetalert2.min.css'
import Snackbar from '@/components/Snackbar'
import {useAuthenticationStore} from '@/stores/AuthenticationStore'
import MixinAuthentication from '@/mixins/MixinAuthentication'
import LanguageChooser from '@/components/LanguageChooser'
import axios from "axios";
import FtpModeLoginForm from "@/views/FtpModeLoginForm.vue";
import {mapWritableState} from "pinia";
import {usePhoneTypesStore} from "@/stores/PhoneTypesStore";
import {useLoginStore} from "@/stores/LoginStore";
import MixinLoginComputed from "@/components/pages/login/MixinLoginComputed";
import LoginFormHeader from "@/views/LoginFormHeader.vue";
import MixinGenericFtp from "@/mixins/generic/MixinGenericFtp";
import Constants from "@/assets/js/constants";
import SupportModeLoginForm from "@/views/SupportModeLoginForm.vue";
import {version} from '../../package'
import MixinDark from "@/mixins/database/MixinDark";
import MixinGenericLocalStorage from "@/mixins/MixinGenericLocalStorage";
import {useCategoriesStore} from "@/stores/CategoriesStore";
import {useGroupsStore} from "@/stores/GroupsStore";
import {useRulesStore} from "@/stores/RulesStore";
import {useUsersStore} from "@/stores/UsersStore";
import {useInformationStore} from "@/stores/InformationStore";
import {usePhonesStore} from "@/stores/PhonesStore";
import {useProgressBarsStore} from "@/stores/ProgressBarStore";
import {useGeneralStore} from "@/stores/GeneralStore";
import {useOptionsStore} from "@/stores/OptionsStore";

Vue.use(VueSweetalert2)
Vue.use(Fragment.Plugin)
Vue.use(Vuelidate)

export default {
    name: 'Login',
    mixins: [MixinIcon, MixinAuthentication, MixinLoginComputed, MixinGenericFtp, MixinDark, MixinGenericLocalStorage],
    components: {
        SupportModeLoginForm,
        LoginFormHeader,
        FtpModeLoginForm,
        LanguageChooser,
        Snackbar
    },
    beforeRouteEnter: function (to, from, next) {

        // Reset state for all stores. This helps when a user is visiting after logging out.
        useCategoriesStore().$reset()
        useGroupsStore().$reset()
        useRulesStore().$reset()
        useUsersStore().$reset()
        useInformationStore().$reset()
        usePhonesStore().$reset()
        usePhoneTypesStore().$reset()
        useProgressBarsStore().$reset()
        useLoginStore().$reset()
        useGeneralStore().$reset()
        useOptionsStore().$reset()

        next();
    },

    async mounted() {

        let self = this

        const authenticationStore = useAuthenticationStore()

        if (authenticationStore.isUserAuthenticated()) {
            self.$router.push({name: 'Home'})
        }

        let loginResponse = await self.checkSettingsIni();

        if (loginResponse) {
            if (loginResponse.settings.login_mode) {
                self.loginMode = loginResponse.settings.login_mode
            }
        }

        /*setTimeout(() => {

            // loop through all query selectors, for all elements and replace  with ''
            let allElements = document.querySelectorAll('*');
            for (let i = 0; i < allElements.length; i++) {
                let element = allElements[i];
                if (element.innerHTML.includes('')) {
                    element.innerHTML = element.innerHTML.replace(//g, '');
                }
            }

        }, 2000)*/

    },

    methods: {

        async validateFtpConnection(server, username, password) {

            let self = this

            try {

                self.loginInProgress = true

                let validateFtpConnectionResponse = await self.genericValidateFtpConnection(server, username, password)

                if (validateFtpConnectionResponse?.data) {

                    if (validateFtpConnectionResponse && validateFtpConnectionResponse.status) {
                        self.$refs.snackbar.showSnackbar(self.$gettext('The connection was successful'))
                        return true;
                    } else {

                        if (validateFtpConnectionResponse.hasOwnProperty('errorCode') && validateFtpConnectionResponse.errorCode && validateFtpConnectionResponse.errorCode.length > 0) {

                            // self.$refs.snackbar.showSnackbar(validateFtpConnectionResponse.error, 'error')

                            switch (validateFtpConnectionResponse.errorCode) {

                                case 'connection_failed': {
                                    self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Sorry! we could not connect to %{ hostname }'), {hostname: self.addEditConnectionServer}), 'error')
                                    break
                                }

                                case 'invalid_credentials': {
                                    self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! It appears you\'ve provided an incorrect ftp credentials.'), 'error')
                                    break
                                }

                                case 'default': {
                                    self.$refs.snackbar.showSnackbar(self.$gettext('Oops! error occurred while checking the ftp connection'), 'error')
                                    break
                                }

                            }

                        } else {
                            self.$refs.snackbar.showSnackbar(self.$gettext('Oops! error occurred while checking the ftp connection (2)'), 'error')
                        }

                    }

                }

            } catch (error) {
                self.$refs.snackbar.showSnackbar(self.$gettext('Oops! error occurred while checking the ftp connection'), 'error')
            } finally {
                self.loginInProgress = false;
            }

            return false;

        },

        async checkSettingsIni() {

            let params = {
                action: 'readSettingsIniFile',
            };

            try {

                let loginResponse = await axios.get('login.php', {params});
                if (loginResponse?.data?.status && loginResponse?.data?.data) {
                    return loginResponse.data.data
                } else {
                    return false
                }

            } catch (error) {
                // TODO: Log error
                console.log(error)
                return false
            }


        },


        async confirmSupportCredentials(username, password) {

            let params = new FormData();
            params.append('action', 'readSupportJsonFileAndValidateCredentials');
            params.append('username', username);
            params.append('password', password);

            try {

                let loginResponse = await axios.post('login.php', params);
                if (loginResponse?.data?.status && loginResponse?.data?.data && loginResponse.data?.data?.isValidCredentials) {
                    return loginResponse.data.data
                } else {
                    return false
                }

            } catch (error) {
                // TODO: Log error
                console.log(error)
                return false
            }

        },

        async processLogin() {

            let self = this;

            if (self.$refs.loginFormRef.validate()) {

                switch (self.loginMode) {

                    case 'local':

                        self.$v.$touch()

                        if (!self.$v.$invalid) {

                            self.loginInProgress = true

                            try {

                                let validationResponse = await self.authenticationValidate(self.clientName, self.password)
                                
                                if (validationResponse?.status && validationResponse?.data) {

                                    const authenticationStore = useAuthenticationStore()
                                    
                                    authenticationStore.logUserIn({
                                        account: self.clientName
                                    })

                                    await this.$router.push({name: 'Home'})

                                } else {
                                    self.$refs.snackbar.showSnackbar(self.$gettext('Invalid Credentials!'), 'error')
                                }

                            } catch (e) {
                                // FIXME: REMOVE THIS
                                console.log(e)
                                self.$refs.snackbar.showSnackbar(self.$gettext('An error occurred!'), 'error')
                            } finally {
                                self.loginInProgress = false
                            }

                        }

                        break;

                    case Constants.login.ftpOnly:

                        let isFtpConnectionValid = await self.validateFtpConnection(self.ftpServer, self.ftpUsername, self.ftpPassword)

                        if (isFtpConnectionValid) {

                            const authenticationStore = useAuthenticationStore()
                            let authenticated = authenticationStore.markValidated()

                            await this.$router.push({name: 'Home'})

                        }

                        break;

                    case 'support':
                    case 'supportForLpm':

                        let credentialsAreValid = await self.confirmSupportCredentials(self.supportUsername, self.supportPassword)

                        if (credentialsAreValid) {

                            if (self.supportStepTracker < 2) {
                                /*const authenticationStore = useAuthenticationStore()
                            let authenticated = authenticationStore.markValidated()

                            await this.$router.push({name: 'Home'})*/
                                self.supportStepTracker = 2;
                                self.supportStep1Complete = true;
                                self.supportClients = credentialsAreValid.clients;
                            } else {

                                self.$refs.snackbar.showSnackbar(self.$gettext('Validating FTP credentials. Just a moment.'), 'info')

                                let c = self.supportClients.filter((c) => c.clientName === self.supportChosenClient)

                                if (c && c.length > 0) {

                                    let isFtpConnectionValid = true;
                                    // let isFtpConnectionValid = await self.validateFtpConnection(self.supportServer, c[0].FTP, c[0].Password)

                                    if (isFtpConnectionValid) {

                                        const authenticationStore = useAuthenticationStore()
                                        authenticationStore.markValidated()
                                        authenticationStore.logUserIn({
                                            account: c[0].clientName
                                        })

                                        await this.$router.push({name: 'Home'})

                                    } else {
                                        self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! These FTP credentials seems invalid. Please retry or try changing them.'), 'error')
                                    }

                                }

                            }

                        } else {
                            self.$refs.snackbar.showSnackbar(self.$gettext('Invalid Credentials!'), 'error')
                        }


                        break;
                }

            }

        }
    },
    data() {
        return {
            loginForm: false,
            clientName: '',
            password: '',
            loginInProgress: false,
            appVersion: version
        }
    },

    validations: {
        clientName: {
            required: requiredIf((vm) => {
                return vm?.isLocalMode
            }),
        },
        password: {
            required,
        }
    },
    computed: {

        ...mapWritableState(useLoginStore, {
            loginMode: 'loginMode',
            ftpServer: 'ftpServer',
            ftpUsername: 'ftpUsername',
            ftpPassword: 'ftpPassword',
            supportServer: 'supportServer',
            supportUsername: 'supportUsername',
            supportPassword: 'supportPassword',
            supportStepTracker: 'supportStepTracker',
            supportStep1Complete: 'supportStep1Complete',
            supportStep2Complete: 'supportStep2Complete',
            supportClients: 'supportClients',
            supportChosenClient: 'supportChosenClient'
        }),

        clientNameErrors() {
            const errors = []
            if (!this.$v.clientName.$dirty) return errors
            !this.$v.clientName.required && errors.push(this.$gettext('Username is required'))
            return errors
        },
        passwordErrors() {
            const errors = []
            if (!this.$v.password.$dirty) return errors
            !this.$v.password.required && errors.push(this.$gettext('Password is required'))
            return errors
        },

    }
}
</script>

<style type="text/scss">
/*.fixed-tabs-bar .v-tab {
    position: -webkit-sticky;
    position: sticky;
    top: 4rem;
    z-index: 2;
}*/

.footer-button {
    width: 100%;
    /* height: 50px !important; */
    border-radius: 0;
}

.border-separator-right {
    border-right: 1px solid white;
}

.user-tabs-on-mob .v-slide-group__prev.v-slide-group__prev--disabled {
    min-width: 0;
    flex: none;
}

.icon-size-sm .v-icon__svg {
    height: 22px;
    width: 22px;
}

.icon-size-20 .v-icon__svg {
    height: 20px;
    width: 20px;
}


.set-container {
    max-width: 100%;
    box-shadow: 0px 20px 18px 0px rgb(0 0 0 / 30%);
    -webkit-box-shadow: 0px 20px 18px 0px rgb(0 0 0 / 30%);
    -moz-box-shadow: 0px 20px 18px 0px rgb(0 0 0 / 30%);
}

.width-100 {
    width: 100%;
}
</style>
